<template>
	<div class="wrapper clear">
		
		<div class="footerDiv wrapper">
		    <ul class="footerUl">
		        <li :class="{'cur': curname == '/'}">
		          <router-link :to="{ name:'homePage' }">
		              <i class="sy"></i>
		              <span>首页</span>
		          </router-link>
		        </li>
		        <li :class="{'cur': curname == '/product'}">
		          <router-link :to="{ name:'productPage' }">
		              <i class="fw"></i>
		              <span>服务</span>
		          </router-link>
		        </li>
		        <li :class="{'cur': curname == '/userIndex'}" @click="toMustLogin('/user/userIndex')">
		              <i class="wd"></i>
		              <span>我的</span>
		        </li>
		    </ul>
		</div>
	</div>
 
</template>
<script>
 	
  	export default {
	    name: 'footerTag',
	    props: {
	      
	    },
	    data(){
	      return {
	        curname: ''
	      }
	    },
	    methods:{
			toMustLogin(page){
				this.axios({
				    method: 'POST',
				    url:'/user/getUserName',
				}).then((res)=>{
						if(res.data.obj != null && res.data.obj != ''){
							// 用户已登录
							window.location.href=page;
						}else{
							//未登录
							window.location.href='/login?targetUrl='+page;
						}
				}).catch((err)=>{
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
	    },
	    created() {
	      this.curname = this.$route.path;
	      if((this.curname.indexOf("user") != -1)|| (this.curname.indexOf("order") != -1) ||(this.curname.indexOf("problem") != -1)){
	      		this.curname="/userIndex";
	      }
	    }
  	}
</script>